import { vesselConstants } from '../../_constants';
import { vesselService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const vesselActions = {
    getAllVessels,
    getVesselById,
    createVessel,
    updateVessel,
    deleteVessel,
    activation,
    getIsActive,
    createVesselStructure,
    updateVesselStructure,
    deleteVesselStructure,
    getVesselStowageTemplate,
    getVesselStowageTemplateByCode,
    createVesselStowageTemplate,
    updateVesselStowageTemplate,
    deleteVesselStowageTemplate,
    getVesselForVesselChange,
    getProCenterIdFromBase,
};

function vesselFetched() { return { type: vesselConstants.VESSEL_FETCHED } }
function vesselFetching() { return { type: vesselConstants.VESSEL_FETCHING } }

function vesselSubmitted() { return { type: vesselConstants.VESSEL_SUBMITTED } }
function vesselSubmitting() { return { type: vesselConstants.VESSEL_SUBMITTING } }

function getAllVessels(skip, take, filter, search) {
    return dispatch => {
        dispatch(vesselFetching());
        dispatch(userActions.allowLeavePage());
        vesselService.getAllVessels(skip, take, filter, search)
            .then(
                vessels => {
                    if (vessels.length > 0) {
                        dispatch(success(vessels));
                        dispatch(vesselFetched());
                    } else {
                        dispatch(vesselFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(vesselFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(vessels) { return { type: vesselConstants.GET_VESSELS, vessels } }
}
function getVesselById(code) {
    return dispatch => {
        dispatch(vesselFetching());
        dispatch(userActions.allowLeavePage());
        vesselService.getVesselById(code)
            .then(
                vessel => {
                    dispatch(success(vessel));
                    dispatch(vesselFetched());
                },
                error => {
                    dispatch(vesselFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(vessel) { return { type: vesselConstants.GET_VESSEL_BY_ID, vessel } }
}
function createVessel(payload) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.createVessel(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.success('Vessel added successfully'))
                    window.location.href = '/master_data/vessels';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateVessel(payload, id) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.updateVessel(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.success('Vessel updated successfully'))
                    window.location.href = '/master_data/vessels';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteVessel(id, type) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        vesselService.deleteVessel(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Vessel deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/vessels';
                            break;
                        default:
                            dispatch(getAllVessels(0, 20));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/vessels';
                            break;
                        default:
                            dispatch(getAllVessels(0, 20));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        vesselService.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getVesselById(id));
                    dispatch(alertActions.success(isActive ? 'Vessel activated successfully' : 'Vessel deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getVesselById(id));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getIsActive() {
    return dispatch => {
        vesselService.getIsActive()
            .then(
                vessels => {
                    if (vessels.length > 0) {
                        dispatch(success(vessels));
                    } else {
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(vessels) { return { type: vesselConstants.GET_VESSELS, vessels } }
}

function createVesselStructure(payload, code) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.createVesselStructure(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.success('Vessel Structure added successfully'))
                    window.location.href = '/master_data/vessels/read/' + code;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function updateVesselStructure(payload, code) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.updateVesselStructure(payload, code)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.success('Vessel Structure updated successfully'))
                    window.location.href = '/master_data/vessels/read/' + code;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteVesselStructure(id) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.deleteVesselStructure(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Vessel Structure deleted successfully'));
                    dispatch(getVesselById(id));
                    window.location.href = '/master_data/vessels/read/' + id;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function getVesselStowageTemplate() {
    return dispatch => {
        dispatch(vesselFetching());
        vesselService.getVesselStowageTemplate()
            .then(
                vesselstowagetemple => {
                    if (vesselstowagetemple.length > 0) {
                        dispatch(success(vesselstowagetemple));
                        dispatch(vesselFetched());
                    } else {
                        dispatch(vesselFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(vesselFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(vesselstowagetemple) { return { type: vesselConstants.GET_VESSELSTOWAGETEMPLATE, vesselstowagetemple } }
}

function getVesselStowageTemplateByCode(code) {
    return dispatch => {
        dispatch(vesselFetching());
        vesselService.getVesselStowageTemplateByCode(code)
            .then(
                vesselstowagetemplecode => {
                    dispatch(success(vesselstowagetemplecode));
                    dispatch(vesselFetched());
                },
                error => {
                    dispatch(vesselFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(vesselstowagetemplecode) { return { type: vesselConstants.GET_VESSELSTOWAGETEMPLATE_BY_CODE, vesselstowagetemplecode } }
}
function createVesselStowageTemplate(payload) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.createVesselStowageTemplate(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.success('Vessel Stowage Template added successfully'))
                    window.location.href = '/master_data/vessel_stowage';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function updateVesselStowageTemplate(payload, code) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.updateVesselStowageTemplate(payload, code)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.success('Vessel Stowage Template updated successfully'))
                    window.location.href = '/master_data/vessel_stowage';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteVesselStowageTemplate(id) {
    return dispatch => {
        dispatch(vesselSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselService.deleteVesselStowageTemplate(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Vessel Stowage Template deleted successfully'));
                    dispatch(getVesselStowageTemplate());
                    window.location.href = '/master_data/vessel_stowage';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(getVesselStowageTemplate());
                }
            );
    };
}
function getVesselForVesselChange() {
    return dispatch => {
        dispatch(vesselFetching());
        vesselService.getVesselForVesselChange()
            .then(
                vesselChangeReguide => {
                    dispatch(success(vesselChangeReguide))
                    dispatch(vesselFetched());
                },
                error => {
                    dispatch(vesselFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(vesselChangeReguide) { return { type: vesselConstants.GET_VESSEL_FOR_CHANGE, vesselChangeReguide } }
}
function getProCenterIdFromBase(payload) {
    return dispatch => {
        vesselService.getProCenterIdFromBase(payload)
            .then(
                PCData => {
                    dispatch(success(PCData));
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(PCData) { return { type: vesselConstants.GET_PROFIT_CENTER, PCData } }
}